export default __webpack_public_path__ + "static/media/424.35ccde27.gif";